import { del } from "@utils/fetch";

export const logout = async () => {
  await del("/api/tenanted/v1/sessions/");

  return;
};
